// 配客嘉官方 LINE 加入好友連結（Premium ID @packageplus）
//
// 使用 LINE custom URL scheme (line://) 而非 Universal Link (https://line.me/R/...)。
// 原因:iOS Universal Link 會根據使用者是否從 app 退回 browser 動態降級偏好,
// 且 line.me 與 liff.line.me 共享 LINE 的 apple-app-site-association,一旦被
// 降級後續 LIFF URL 也會在 Safari 開啟。custom scheme 不走 Universal Link 決策,
// 不讀也不寫那層偏好快取,行為穩定。
// 代價:LINE 未安裝時 line:// 無 fallback,但我們用戶基本都有 LINE。
export const LINE_OFFICIAL_URL = 'line://ti/p/@packageplus';

// LIFF 跳轉工具：把使用者從外部瀏覽器直接帶進 LINE app 的對應 LIFF 頁面，
// 行為：手機有裝 LINE → 系統詢問開啟 LINE → 進入 LIFF（內部登入走 native 流程）→ 按 × 回 OA chat
// 沒裝 LINE / 桌機 → LINE 側會 fallback 成要求登入的 web 流程
const LIFF_ID = process.env.REACT_APP_LIFFID || '';
export const toLiffUrl = (path: string) =>
  `https://liff.line.me/${LIFF_ID}${path.startsWith('/') ? path : `/${path}`}`;

// 歸還地圖 LIFF 入口
export const LIFF_MAP_URL = toLiffUrl('/nearby');
// 常見問答 LIFF 入口
export const LIFF_PROBLEM_URL = toLiffUrl('/problem');
// 電商優惠券領取 LIFF 入口（歸還完成彈窗「領取優惠券」使用）
// 原本跳 LINE_OFFICIAL_URL 後要使用者再點 rich menu + 可能觸發二次登入；
// 改走 LIFF URL 後，LINE app 會直接 init LIFF 並使用 native LINE session，不需再登一次
export const LIFF_COUPON_CLAIM_URL = toLiffUrl('/discount/ecommerce');

// 宅配通(E-can)歸還寄件 Google 表單。
// 只在掃「綠色歸還袋」(/rent?source=greenbag)時，於「選擇歸還通路」頁顯示宅配通鈕。
// 使用者填完表單 → 答覆寫進 Google Sheet → management-backend 的
// EcanGoogleSheetIntakeService 排程拉單 → 自動建立宅配通托運單。
export const ECAN_DELIVERY_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScul0lJ2YUdTb_YB5eBnxnF6UOYyi4U9ODr09ab0XSbboyaJQ/viewform';

// 品牌色
export const BRAND_GREEN = '#3db270';
export const BRAND_GRAY = '#77777A';
